// client/src/pages/ChangePassword.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import zxcvbn from 'zxcvbn';
import logo from '../assets/chitconnect-logo-blue.png';
import '../App.css';
import { apiFetch } from '../lib/api';

export default function ChangePassword() {
  const [form, setForm] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [showNew, setShowNew] = useState(false);
  const [showOld, setShowOld] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [message, setMessage] = useState('');
  const [strength, setStrength] = useState(0);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
    if (name === 'newPassword') setStrength(zxcvbn(value).score);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.newPassword !== form.confirmPassword) {
      setMessage('❌ Passwords do not match.');
      return;
    }

    try {
      const res = await apiFetch('/api/users/change-password', {
        method: 'POST',
        body: JSON.stringify(form),
      });

      let data = null;
      try { data = await res.json(); } catch {}

      if (res.ok) {
        setMessage('✅ Password changed successfully.');
        setTimeout(() => navigate('/'), 1500);
      } else {
        setMessage(`❌ ${data?.error || `Request failed (${res.status})`}`);
      }
    } catch {
      setMessage('❌ Server error.');
    }
  };

  const strengthLabel = ['Too Weak', 'Weak', 'Fair', 'Good', 'Strong'];

  return (
    <div className="register-page">
      <form className="register-form" onSubmit={handleSubmit}>
        <img src={logo} alt="ChitConnect" className="register-logo" />
        <h2>Change Password</h2>

        <label>Old Password</label>
        <div className="password-wrapper">
          <input
            type={showOld ? 'text' : 'password'}
            name="oldPassword"
            value={form.oldPassword}
            onChange={handleChange}
            required
          />
          <span onClick={() => setShowOld(!showOld)} className="toggle-password">
            {showOld ? '🙈' : '👁️'}
          </span>
        </div>

        <div className="form-group">
          <label>New Password</label>
          <div className="password-wrapper">
            <input
              type={showNew ? 'text' : 'password'}
              name="newPassword"
              value={form.newPassword}
              onChange={handleChange}
              required
            />
            <span onClick={() => setShowNew(!showNew)} className="toggle-password">
              {showNew ? '🙈' : '👁️'}
            </span>
          </div>

          {form.newPassword && (
            <>
              <div className={`strength-meter strength-${strength}`}>
                <div style={{ width: `${(strength + 1) * 20}%` }} />
              </div>
              <small>Password Strength: {strengthLabel[strength]}</small>
            </>
          )}
        </div>

        <div className="form-group">
          <label>Confirm New Password</label>
          <div className="password-wrapper">
            <input
              type={showConfirm ? 'text' : 'password'}
              name="confirmPassword"
              value={form.confirmPassword}
              onChange={handleChange}
              required
            />
            <span onClick={() => setShowConfirm(!showConfirm)} className="toggle-password">
              {showConfirm ? '🙈' : '👁️'}
            </span>
          </div>
        </div>

        <button type="submit" className="submit-btn">Update Password</button>
        {message && <p className="form-message">{message}</p>}
      </form>
    </div>
  );
}
